import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  DocumentOverallStatesEnum,
  DocumentTypesEnum,
} from '../../../document-data/document-data.data';
import { CalculationResult } from '../../../document-data/sub-models/calculation-result.model';
import { States } from '../../../document-data/sub-models/states.model';
import { Toggles } from '../../../features-data/sub-models/toggles.model';
import { UtilsService } from '../../services/utils/utils.service';
import { IIcon } from '../icon/icon.interface';
import { IconSizesEnum } from '../icon/icons-sizes.enum';

@Component({
  selector: 'app-document-status',
  templateUrl: './document-status.component.html',
  styleUrls: ['./document-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentStatusComponent implements OnChanges {
  @Input() documentType: DocumentTypesEnum;
  @Input() documentState: States;
  @Input() documentCalculationResult: CalculationResult;
  @Input() showRecurringIcon: boolean;
  @Input() featureToggles: Toggles;

  recurringIcon: IIcon;
  status: string;
  printedIcon: IIcon;
  isPaid: boolean;

  constructor(private _utilsService: UtilsService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes.documentState || changes.featureToggles) &&
      this.documentState &&
      this.featureToggles
    ) {
      const state: DocumentOverallStatesEnum = this._utilsService.calculateDocState(
        this.documentState,
        this.featureToggles
      );

      this.isPaid = state === DocumentOverallStatesEnum.fully_paid;
      this.status = state || null;
    } else {
      this.status = null;
    }
  }

  ngOnInit() {
    this.recurringIcon = {
      name: 'recurring',
      size: IconSizesEnum.small,
    };
    this.printedIcon = {
      name: 'printed',
      size: IconSizesEnum.small,
    };
  }
}
